const resetMiddleware =
  (next: any) => (reducer: any, initialState: any, enhancer: any) => {
    let resetType = 'RESET';
    let resetData = 'state';

    const enhanceReducer = (state: any, action: any) => {
      if (action.type === resetType) {
        state = action[resetData];
      }
      return reducer(state, action);
    };

    return next(enhanceReducer, initialState, enhancer);
  };
export default resetMiddleware;
